import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import PropTypes from 'prop-types';
// Models
import mDistribution from 'models/distribution';
// Custom
import { getDistributionsList, deleteDistribution, refreshList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import { addPath, navigateToShow } from 'distributions/navigation';
import { AddTextButton } from 'components/buttons/TextButtons';
import MainListTemplate from 'components/templates/MainListTemplate';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withLoading from 'hocs/WithLoading';
import withTitle from 'hocs/WithTitle';
import DistributionFilters from 'distributions/assets/main/DistributionFilters';
import DistributionRow from 'distributions/assets/main/DistributionRow';

class DistributionsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteDistribution = this.handleDeleteDistribution.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { deleted, handleRefreshList } = this.props;
    if (!prevProps.deleted && deleted) {
      handleRefreshList();
    }
  }

  // Handlers
  handleDeleteDistribution(distribution) {
    const { handleDisplayConfirm, handleDeleteDistribution } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteDistribution', values: { distributionDesc: mDistribution.desc(distribution) } },
      () => handleDeleteDistribution(distribution.id),
    );
  }

  handleRowDbleClick(distribution) {
    const { handleStartLoading } = this.props;
    if (distribution) {
      // Display loader and display distribution
      handleStartLoading();
      _delay(() => navigateToShow(distribution.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <DistributionRow
        {...props}
        onDelete={this.handleDeleteDistribution}
      />
    );
  }

  render() {
    const { distributions, handleGetDistributionsList } = this.props;

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.distributionsList" />
        }
        icon={mDistribution.icon}
        displayRefresh
        actionButtons={[
          <AddTextButton key="add" primary path={addPath()} />,
        ]}
        name={mDistribution.name}
        listFeatures={mDistribution.listFeatures}
        withActions
        nbActions={2}
        elementsData={{
          loading: distributions.loading,
          elements: distributions.elements,
          handleGetList: handleGetDistributionsList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={
          <DistributionFilters />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

DistributionsList.propTypes = {
  distributions: fullListShape.isRequired,
  deleted: PropTypes.bool.isRequired,
  handleRefreshList: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetDistributionsList: PropTypes.func.isRequired,
  handleDeleteDistribution: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  distributions: state.distribution.list,
  deleted: state.distribution.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleGetDistributionsList: (pagination, sort, filters) => {
    dispatch(getDistributionsList(pagination, sort, filters));
  },
  handleDeleteDistribution: (id) => {
    dispatch(deleteDistribution(id));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmDialog,
  withLoading,
  withTitle('pageTitle.distributions'),
)(DistributionsList);



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/list/components/DistributionsList.js